<app-header-latest></app-header-latest>
<div class="api-hero">
  <div class="container-wrapper">
    <div>
      <div class="api-version-badge">v2.4.1 — Latest Stable</div>
      <div class="section-eyebrow" style="color:#67e8f9;">⚡ REST API REFERENCE</div>
      <h1>NeoHRMZ<br>REST API</h1>
      <p>A complete, versioned REST API for integrating NeoHRMZ data into your applications. All endpoints use standard HTTP methods and return JSON.</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap;">
        <a href="documentation.html" class="btn btn-primary" style="background:#0e7490;">Quick Start Guide</a>
        <a href="#" class="btn btn-outline" style="color:#67e8f9;border-color:rgba(103,232,249,0.3);">Postman Collection ↗</a>
      </div>
    </div>
    <div>
      <div class="endpoint-widget">
        <div class="endpoint-widget-bar">
          <span class="method-badge get">GET</span>
          <span class="endpoint-path">/v2/employees</span>
        </div>
        <div class="endpoint-body">
          <span style="color:#fbbf24;"></span><br>
          &nbsp;&nbsp;<span style="color:#60a5fa;">"data"</span>: [<br>
          &nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#fbbf24;"></span><br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#60a5fa;">"id"</span>: <span style="color:#4ade80;">"emp_01HXQ..."</span>,<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#60a5fa;">"name"</span>: <span style="color:#4ade80;">"Priya Agarwal"</span>,<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#60a5fa;">"department"</span>: <span style="color:#4ade80;">"Engineering"</span>,<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#60a5fa;">"status"</span>: <span style="color:#4ade80;">"active"</span><br>
          &nbsp;&nbsp;&nbsp;&nbsp;<span style="color:#fbbf24;"></span><br>
          &nbsp;&nbsp;],<br>
          &nbsp;&nbsp;<span style="color:#60a5fa;">"meta"</span>:  <span style="color:#60a5fa;">"total"</span>: <span style="color:#f97316;">248</span>, <span style="color:#60a5fa;">"page"</span>: <span style="color:#f97316;">1</span> <br>
          <span style="color:#fbbf24;"></span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ENDPOINT CATEGORIES -->
<section class="api-endpoints-section">
  <div class="container-wrapper">
    <div class="api-sec-head">
      <span class="section-eyebrow" style="color:#67e8f9;">📡 ENDPOINT CATEGORIES</span>
      <h2>Browse the<br>Full API Surface</h2>
      <p>Organized into logical resource categories. Each endpoint includes request/response schemas, error codes, and runnable examples.</p>
    </div>
    <div class="api-cat-grid">
      <div class="api-cat-card">
        <div class="api-cat-card__icon">👥</div>
        <div class="api-cat-card__title">Employees</div>
        <div class="api-cat-card__count">12 endpoints</div>
        <div class="api-cat-card__routes">
          <div class="api-cat-card__route">GET /v2/employees</div>
          <div class="api-cat-card__route">POST /v2/employees</div>
          <div class="api-cat-card__route">GET /v2/employees/:id</div>
          <div class="api-cat-card__route">PATCH /v2/employees/:id</div>
        </div>
      </div>
      <div class="api-cat-card">
        <div class="api-cat-card__icon">💰</div>
        <div class="api-cat-card__title">Payroll</div>
        <div class="api-cat-card__count">8 endpoints</div>
        <div class="api-cat-card__routes">
          <div class="api-cat-card__route">GET /v2/payroll/runs</div>
          <div class="api-cat-card__route">POST /v2/payroll/runs</div>
          <div class="api-cat-card__route">POST /v2/payroll/runs/:id/approve</div>
          <div class="api-cat-card__route">GET /v2/payroll/payslips</div>
        </div>
      </div>
      <div class="api-cat-card">
        <div class="api-cat-card__icon">🕐</div>
        <div class="api-cat-card__title">Attendance</div>
        <div class="api-cat-card__count">10 endpoints</div>
        <div class="api-cat-card__routes">
          <div class="api-cat-card__route">POST /v2/attendance/clock-in</div>
          <div class="api-cat-card__route">POST /v2/attendance/clock-out</div>
          <div class="api-cat-card__route">GET /v2/attendance/summary</div>
          <div class="api-cat-card__route">GET /v2/attendance/leaves</div>
        </div>
      </div>
      <div class="api-cat-card">
        <div class="api-cat-card__icon">🎯</div>
        <div class="api-cat-card__title">Recruitment</div>
        <div class="api-cat-card__count">14 endpoints</div>
        <div class="api-cat-card__routes">
          <div class="api-cat-card__route">GET /v2/jobs</div>
          <div class="api-cat-card__route">POST /v2/jobs</div>
          <div class="api-cat-card__route">GET /v2/candidates</div>
          <div class="api-cat-card__route">POST /v2/candidates/:id/move</div>
        </div>
      </div>
      <div class="api-cat-card">
        <div class="api-cat-card__icon">📈</div>
        <div class="api-cat-card__title">Performance</div>
        <div class="api-cat-card__count">9 endpoints</div>
        <div class="api-cat-card__routes">
          <div class="api-cat-card__route">GET /v2/okrs</div>
          <div class="api-cat-card__route">POST /v2/reviews</div>
          <div class="api-cat-card__route">GET /v2/feedback</div>
          <div class="api-cat-card__route">PATCH /v2/okrs/:id</div>
        </div>
      </div>
      <div class="api-cat-card">
        <div class="api-cat-card__icon">🔔</div>
        <div class="api-cat-card__title">Webhooks</div>
        <div class="api-cat-card__count">6 endpoints</div>
        <div class="api-cat-card__routes">
          <div class="api-cat-card__route">GET /v2/webhooks</div>
          <div class="api-cat-card__route">POST /v2/webhooks</div>
          <div class="api-cat-card__route">DELETE /v2/webhooks/:id</div>
          <div class="api-cat-card__route">POST /v2/webhooks/test</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- AUTH -->
<section class="api-auth-section">
  <div class="container-wrapper">
    <div class="api-sec-head">
      <span class="section-eyebrow" style="color:#67e8f9;">🔐 AUTHENTICATION</span>
      <h2>Secure Every<br>API Request</h2>
      <p>Choose the authentication method that best fits your integration — API keys for server-to-server, OAuth 2.0 for user-facing apps.</p>
    </div>
    <div class="api-auth-grid">
      <div class="api-auth-card">
        <div class="api-auth-card__title">🔑 API Key Authentication</div>
        <div class="api-auth-card__desc">Pass your API key in the Authorization header. Best for server-to-server integrations and backend scripts where user identity is not required.</div>
        <div style="background:#0f1117;border-radius:8px;padding:16px;font-family:monospace;font-size:12px;color:#e2e8f0;">
          Authorization: Bearer hrm_live_••••••••
        </div>
      </div>
      <div class="api-auth-card">
        <div class="api-auth-card__title">🔐 OAuth 2.0</div>
        <div class="api-auth-card__desc">Use the OAuth 2.0 Authorization Code flow for user-facing applications. Supports PKCE for single-page apps. Scopes control which resources the token can access.</div>
        <div style="background:#0f1117;border-radius:8px;padding:16px;font-family:monospace;font-size:12px;color:#e2e8f0;">
          GET /oauth/authorize?<br>client_id=...&amp;scope=employees:read
        </div>
      </div>
    </div>
  </div>
</section>

<!-- RATE LIMITS -->
<section class="rate-section">
  <div class="container-wrapper">
    <div class="api-sec-head">
      <span class="section-eyebrow" style="color:#67e8f9;">⚡ RATE LIMITS</span>
      <h2>Request Limits<br>by Plan</h2>
      <p>Rate limits are applied per API key, per minute. Exceeding limits returns a 429 with a Retry-After header.</p>
    </div>
    <table class="rate-table" style="margin-top:48px;">
      <thead>
        <tr>
          <th class="rate-th">Plan</th>
          <th class="rate-th">Requests / Minute</th>
          <th class="rate-th">Burst Limit</th>
          <th class="rate-th">Monthly Cap</th>
        </tr>
      </thead>
      <tbody>
        <tr class="rate-row"><td class="rate-td"><span class="tier-tag free">Free</span></td><td class="rate-td">60</td><td class="rate-td">100</td><td class="rate-td">10,000</td></tr>
        <tr class="rate-row"><td class="rate-td"><span class="tier-tag growth">Growth</span></td><td class="rate-td">300</td><td class="rate-td">500</td><td class="rate-td">100,000</td></tr>
        <tr class="rate-row"><td class="rate-td"><span class="tier-tag pro">Pro</span></td><td class="rate-td">1,000</td><td class="rate-td">2,000</td><td class="rate-td">Unlimited</td></tr>
        <tr class="rate-row"><td class="rate-td"><span class="tier-tag ent">Enterprise</span></td><td class="rate-td">Custom</td><td class="rate-td">Custom</td><td class="rate-td">Unlimited</td></tr>
      </tbody>
    </table>
  </div>
</section>

<!-- SDK -->
<section class="api-sdk-section">
  <div class="container-wrapper">
    <div class="api-sec-head">
      <span class="section-eyebrow" style="color:#67e8f9;">🛠️ CLIENT LIBRARIES</span>
      <h2>Official SDKs for<br>Every Language</h2>
      <p>Fully typed, auto-generated from our OpenAPI spec, and updated with every API version release.</p>
    </div>
    <div class="api-sdk-grid" style="margin-top:48px;">
      <div class="api-sdk-card"><div class="api-sdk-card__icon">🟨</div><div class="api-sdk-card__lang">JavaScript</div><div class="api-sdk-card__ver">v2.4.1</div></div>
      <div class="api-sdk-card"><div class="api-sdk-card__icon">🐍</div><div class="api-sdk-card__lang">Python</div><div class="api-sdk-card__ver">v2.4.0</div></div>
      <div class="api-sdk-card"><div class="api-sdk-card__icon">💎</div><div class="api-sdk-card__lang">Ruby</div><div class="api-sdk-card__ver">v2.3.2</div></div>
      <div class="api-sdk-card"><div class="api-sdk-card__icon">☕</div><div class="api-sdk-card__lang">Java</div><div class="api-sdk-card__ver">v2.3.0</div></div>
      <div class="api-sdk-card"><div class="api-sdk-card__icon">🐘</div><div class="api-sdk-card__lang">PHP</div><div class="api-sdk-card__ver">v2.2.1</div></div>
      <div class="api-sdk-card"><div class="api-sdk-card__icon">🐹</div><div class="api-sdk-card__lang">Go</div><div class="api-sdk-card__ver">v2.4.1</div></div>
      <div class="api-sdk-card"><div class="api-sdk-card__icon">🦀</div><div class="api-sdk-card__lang">Rust</div><div class="api-sdk-card__ver">Beta</div></div>
      <div class="api-sdk-card"><div class="api-sdk-card__icon">🔷</div><div class="api-sdk-card__lang">.NET</div><div class="api-sdk-card__ver">v2.3.0</div></div>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>